
import {ref, onMounted, watch, computed} from 'vue';
import { useStore } from 'vuex';
import SectionNavigation from 'VueComponents/SectionNavigation/SectionNavigation.vue';
import FinishesBar from 'VueComponents/FinishesBar/FinishesBar.vue';
import ProductGrid from 'VueComponents/ProductGrid/ProductGrid.vue';
import { FamilyRequest } from 'Api/apis';
import ProductFilteringContent from "VueComponents/ProductFiltering/ProductFilteringContent.vue";

export default {
	name: "CategoryBrowse",
	components: {
		ProductFilteringContent,
		SectionNavigation,
		FinishesBar,
		ProductGrid,
	},

	setup() {
		// Store and initialize the category data and language
		const store = useStore();
		const stickyNav = ref(null);
		const translations = ref({});

		/**
		 * Sets the category information and language in the store
		 */
		const setCategoryInfoAndLanguage = async () => {
			let categoryBrowseEl = document.getElementById('categoryBrowseData');

			// Set category info in the store
			await store.commit('setCategorySlug', categoryBrowseEl.getAttribute('data-category-slug'));
			await store.commit('setCategoryName', categoryBrowseEl.getAttribute('data-product-category'));
			await store.commit('setCategoryDescription', categoryBrowseEl.getAttribute('data-product-description'));
			await store.commit('setLanguage', categoryBrowseEl.getAttribute('data-language'));
			await store.commit('setGroupBy', categoryBrowseEl.getAttribute('data-product-group-by'))
		};

		/**
		 * Fetches the data from the API
		 */
		const getData = async () => {
			store.commit('setResponseData', await FamilyRequest(store.getters?.categorySlug, store.getters?.groupBy, store.getters?.language));
		};

		const getTranslations = () => {
			let productFilteringParentDiv = document.getElementById('categoryBrowseData');
			return JSON.parse(productFilteringParentDiv.getAttribute('data-translations'));
		};

		/**
		 * Moves the sticky navigation to the top of the category container
		 */
		const moveStickyNav = () => {
			let categoryBrowseContainer = document.querySelector('.product-family-container');
			if (categoryBrowseContainer) {
				categoryBrowseContainer.insertBefore(stickyNav.value, categoryBrowseContainer.firstChild);
			}
		};

		onMounted(async () => {
			moveStickyNav();
			translations.value = getTranslations();
			await setCategoryInfoAndLanguage();
			await getData();
		});

		// Expose variables to the template and other options API hooks
		return {
			store,
			stickyNav,
			translations
		};
	},
}
